import ABQuestion from '../components/questions/abQuestion/abQuestion';
import FrequencyQuestion from '../components/questions/frequencyQuestion/frequencyQuestion';
import BdiScoreQuestion from '../components/questions/bdiScoreQuestion/bdiScoreQuestion';
import NumericQuestion from '../components/questions/numericQuestion/numericQuestion';
import HourQuestion from '../components/questions/hourQuestion/hourQuestion';
import DropdownQuestion from '../components/questions/dropdownQuestion/dropdownQuestion';
import TextQuestion from '../components/questions/textQuestion/textQuestion';
import ageRanges from '../data/ageRanges';

const psqiFrequencyOptions = [
  'Ninguna vez en el ultimo mes',
  'Menos de una vez a la semana',
  'Una o dos veces a la semana',
  'Tres o mas veces a la semana'
];

const psqiSleepProblemQuestions = [
  '¿Durante el último mes, cuántas veces ha tenido problemas para dormir por no poder conciliar el sueño en la primera media hora?',
  '¿Durante el último mes, cuántas veces ha tenido problemas para dormir por despertarse durante la noche o de madrugada?',
  '¿Durante el último mes, cuántas veces ha tenido problemas para dormir por tener que levantarse para ir al sanitario?',
  '¿Durante el último mes, cuántas veces ha tenido problemas para dormir por no poder respirar bien?',
  '¿Durante el último mes, cuántas veces ha tenido problemas para dormir por toser o roncar ruidosamente?',
  '¿Durante el último mes, cuántas veces ha tenido problemas para dormir por sentir frío?',
  '¿Durante el último mes, cuántas veces ha tenido problemas para dormir por sentir demasiado calor?',
  '¿Durante el último mes, cuántas veces ha tenido problemas para dormir por tener pesadillas o malos sueños?',
  '¿Durante el último mes, cuántas veces ha tenido problemas para dormir por sufrir dolores?',
  '¿Durante el último mes, cuántas veces ha tenido problemas para dormir por otras razones?'
];

const pssLabels = ['Nunca', 'Casi nunca', 'De vez en cuando', 'A menudo', 'Muy a menudo'];

const pssQuestions = [
  {
    question: '¿En el último mes, con qué frecuencia ha estado afectado por algo que ha ocurrido inesperadamente?',
    invertOrder: true
  },
  {
    question: '¿En el último mes, con qué frecuencia se ha sentido incapaz de controlar las cosas importantes en su vida?',
    invertOrder: true
  },
  {
    question: '¿En el último mes, con qué frecuencia se ha sentido nervioso o estresado?',
    invertOrder: true
  },
  {
    question: '¿En el último mes, con qué frecuencia ha manejado con éxito los pequeños problemas irritantes de la vida?',
    invertOrder: false
  },
  {
    question:
      '¿En el último mes, con qué frecuencia ha sentido que ha afrontado efectivamente los cambios importantes que han estado ocurriendo en su vida?',
    invertOrder: false
  },
  {
    question:
      '¿En el último mes, con qué frecuencia ha estado seguro sobre su capacidad para manejar sus problemas personales?',
    invertOrder: false
  },
  {
    question: '¿En el último mes, con qué frecuencia ha sentido que las cosas le van bien?',
    invertOrder: false
  },
  {
    question: '¿En el último mes, con qué frecuencia ha sentido que no podía afrontar todas las cosas que tenía que hacer?',
    invertOrder: true
  },
  {
    question: '¿En el último mes, con qué frecuencia ha podido controlar las dificultades de su vida?',
    invertOrder: false
  },
  {
    question: '¿En el último mes, con qué frecuencia ha sentido que tenía todo bajo control?',
    invertOrder: false
  },
  {
    question:
      '¿En el último mes, con qué frecuencia ha estado enfadado porque las cosas que le han ocurrido estaban fuera de su control?',
    invertOrder: true
  },
  {
    question: '¿En el último mes, con qué frecuencia ha pensado sobre las cosas que le quedan por hacer?',
    invertOrder: true
  },
  {
    question: '¿En el último mes, con qué frecuencia ha podido controlar la forma de pasar el tiempo?',
    invertOrder: false
  },
  {
    question: '¿En el último mes, con qué frecuencia ha sentido que las dificultades se acumulan tanto que no puede superarlas?',
    invertOrder: true
  }
];

const generalHealtQuestions = [
  // Datos generales (igual que NOM-035)
  {
    Component: TextQuestion,
    question: '¿Cuál es tu correo electrónico?',
    field: 'email',
    type: 'email',
    required: true
  },
  {
    Component: ABQuestion,
    question: '¿Cuál es tu sexo biológico?',
    optionA: 'Masculino',
    optionB: 'Femenino',
    field: 'biologicalSex',
    required: true
  },
  {
    Component: DropdownQuestion,
    question: '¿Cuál es tu rango de edad?',
    options: ageRanges,
    field: 'ageRange',
    required: true
  },

  // BAI - Segunda tanda
  {
    Component: FrequencyQuestion,
    question: 'Torpe o entumecido.',
    labels: ['En absoluto', 'Levemente', 'Moderadamente', 'Severamente'],
    invertOrder: true,
    field: 'bai_item1',
    required: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Acalorado.',
    labels: ['En absoluto', 'Levemente', 'Moderadamente', 'Severamente'],
    invertOrder: true,
    field: 'bai_item2',
    required: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Con temblor en las piernas.',
    labels: ['En absoluto', 'Levemente', 'Moderadamente', 'Severamente'],
    invertOrder: true,
    field: 'bai_item3',
    required: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Incapaz de relajarse.',
    labels: ['En absoluto', 'Levemente', 'Moderadamente', 'Severamente'],
    invertOrder: true,
    field: 'bai_item4',
    required: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Con temor a que ocurra lo peor.',
    labels: ['En absoluto', 'Levemente', 'Moderadamente', 'Severamente'],
    invertOrder: true,
    field: 'bai_item5',
    required: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Mareado, o que se le va la cabeza.',
    labels: ['En absoluto', 'Levemente', 'Moderadamente', 'Severamente'],
    invertOrder: true,
    field: 'bai_item6',
    required: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Con latidos del corazón fuertes y acelerados.',
    labels: ['En absoluto', 'Levemente', 'Moderadamente', 'Severamente'],
    invertOrder: true,
    field: 'bai_item7',
    required: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Inestable.',
    labels: ['En absoluto', 'Levemente', 'Moderadamente', 'Severamente'],
    invertOrder: true,
    field: 'bai_item8',
    required: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Atemorizado o asustado.',
    labels: ['En absoluto', 'Levemente', 'Moderadamente', 'Severamente'],
    invertOrder: true,
    field: 'bai_item9',
    required: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Nervioso.',
    labels: ['En absoluto', 'Levemente', 'Moderadamente', 'Severamente'],
    invertOrder: true,
    field: 'bai_item10',
    required: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Con sensación de bloqueo.',
    labels: ['En absoluto', 'Levemente', 'Moderadamente', 'Severamente'],
    invertOrder: true,
    field: 'bai_item11',
    required: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Con temblores en las manos.',
    labels: ['En absoluto', 'Levemente', 'Moderadamente', 'Severamente'],
    invertOrder: true,
    field: 'bai_item12',
    required: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Inquieto, inseguro.',
    labels: ['En absoluto', 'Levemente', 'Moderadamente', 'Severamente'],
    invertOrder: true,
    field: 'bai_item13',
    required: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Con miedo a perder el control.',
    labels: ['En absoluto', 'Levemente', 'Moderadamente', 'Severamente'],
    invertOrder: true,
    field: 'bai_item14',
    required: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Con sensación de ahogo.',
    labels: ['En absoluto', 'Levemente', 'Moderadamente', 'Severamente'],
    invertOrder: true,
    field: 'bai_item15',
    required: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Con temor a morir.',
    labels: ['En absoluto', 'Levemente', 'Moderadamente', 'Severamente'],
    invertOrder: true,
    field: 'bai_item16',
    required: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Con miedo.',
    labels: ['En absoluto', 'Levemente', 'Moderadamente', 'Severamente'],
    invertOrder: true,
    field: 'bai_item17',
    required: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Con problemas digestivos.',
    labels: ['En absoluto', 'Levemente', 'Moderadamente', 'Severamente'],
    invertOrder: true,
    field: 'bai_item18',
    required: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Con desvanecimientos.',
    labels: ['En absoluto', 'Levemente', 'Moderadamente', 'Severamente'],
    invertOrder: true,
    field: 'bai_item19',
    required: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Con rubor facial.',
    labels: ['En absoluto', 'Levemente', 'Moderadamente', 'Severamente'],
    invertOrder: true,
    field: 'bai_item20',
    required: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Con sudores, fríos o calientes.',
    labels: ['En absoluto', 'Levemente', 'Moderadamente', 'Severamente'],
    invertOrder: true,
    field: 'bai_item21',
    required: true
  },

  // BDI - Tercera tanda (seleccion unica)
  {
    Component: BdiScoreQuestion,
    question: 'Tristeza',
    options: [
      'No me siento triste.',
      'Me siento triste gran parte del tiempo.',
      'Me siento triste todo el tiempo.',
      'Me siento tan triste o soy tan infeliz que no puedo soportarlo.'
    ],
    field: 'bdi_item1',
    uniqueChoice: true,
    required: true
  },
  {
    Component: BdiScoreQuestion,
    question: 'Pesimismo',
    options: [
      'No estoy desalentado respecto de mi futuro.',
      'Me siento mas desalentado respecto de mi futuro que lo que solia estarlo.',
      'No espero que las cosas funcionen para mi.',
      'Siento que no hay esperanza para mi futuro y que solo puede empeorar.'
    ],
    field: 'bdi_item2',
    uniqueChoice: true,
    required: true
  },
  {
    Component: BdiScoreQuestion,
    question: 'Fracaso',
    options: [
      'No me siento como un fracasado.',
      'He fracasado mas de lo que hubiera debido.',
      'Cuando miro hacia atras, veo muchos fracasos.',
      'Siento que como persona soy un fracaso total.'
    ],
    field: 'bdi_item3',
    uniqueChoice: true,
    required: true
  },
  {
    Component: BdiScoreQuestion,
    question: 'Pérdida de placer',
    options: [
      'Obtengo tanto placer como siempre por las cosas de las que disfruto.',
      'No disfruto tanto de las cosas como solia hacerlo.',
      'Obtengo muy poco placer de las cosas que solia disfrutar.',
      'No puedo obtener ningun placer de las cosas de las que solia disfrutar.'
    ],
    field: 'bdi_item4',
    uniqueChoice: true,
    required: true
  },
  {
    Component: BdiScoreQuestion,
    question: 'Sentimientos de culpa',
    options: [
      'No me siento particularmente culpable.',
      'Me siento culpable respecto de varias cosas que he hecho o que deberia haber hecho.',
      'Me siento bastante culpable la mayor parte del tiempo.',
      'Me siento culpable todo el tiempo.'
    ],
    field: 'bdi_item5',
    uniqueChoice: true,
    required: true
  },
  {
    Component: BdiScoreQuestion,
    question: 'Sentimientos de castigo',
    options: [
      'No siento que este siendo castigado.',
      'Siento que tal vez pueda ser castigado.',
      'Espero ser castigado.',
      'Siento que estoy siendo castigado.'
    ],
    field: 'bdi_item6',
    uniqueChoice: true,
    required: true
  },
  {
    Component: BdiScoreQuestion,
    question: 'Disconformidad con uno mismo',
    options: [
      'Siento acerca de mi lo mismo que siempre.',
      'He perdido la confianza en mi mismo.',
      'Estoy decepcionado conmigo mismo.',
      'No me gusto a mi mismo.'
    ],
    field: 'bdi_item7',
    uniqueChoice: true,
    required: true
  },
  {
    Component: BdiScoreQuestion,
    question: 'Autocrítica',
    options: [
      'No me critico ni me culpo mas de lo habitual.',
      'Estoy mas critico conmigo mismo de lo que solia estarlo.',
      'Me critico a mi mismo por todos mis errores.',
      'Me culpo a mi mismo por todo lo malo que sucede.'
    ],
    field: 'bdi_item8',
    uniqueChoice: true,
    required: true
  },
  {
    Component: BdiScoreQuestion,
    question: 'Pensamientos o deseos suicidas',
    options: [
      'No tengo ningun pensamiento de matarme.',
      'He tenido pensamientos de matarme, pero no lo haria.',
      'Querria matarme.',
      'Me mataria si tuviera la oportunidad de hacerlo.'
    ],
    field: 'bdi_item9',
    uniqueChoice: true,
    required: true
  },
  {
    Component: BdiScoreQuestion,
    question: 'Llanto',
    options: [
      'No lloro mas de lo que solia hacerlo.',
      'Lloro mas de lo que solia hacerlo.',
      'Lloro por cualquier pequenez.',
      'Siento ganas de llorar pero no puedo.'
    ],
    field: 'bdi_item10',
    uniqueChoice: true,
    required: true
  },
  {
    Component: BdiScoreQuestion,
    question: 'Agitación',
    options: [
      'No estoy mas inquieto o tenso que lo habitual.',
      'Me siento mas inquieto o tenso que lo habitual.',
      'Estoy tan inquieto o agitado que me es dificil quedarme quieto.',
      'Estoy tan inquieto o agitado que tengo que estar siempre en movimiento o haciendo algo.'
    ],
    field: 'bdi_item11',
    uniqueChoice: true,
    required: true
  },
  {
    Component: BdiScoreQuestion,
    question: 'Pérdida de interés',
    options: [
      'No he perdido el interes en otras actividades o personas.',
      'Estoy menos interesado que antes en otras personas o cosas.',
      'He perdido casi todo el interes en otras personas o cosas.',
      'Me es dificil interesarme por algo.'
    ],
    field: 'bdi_item12',
    uniqueChoice: true,
    required: true
  },
  {
    Component: BdiScoreQuestion,
    question: 'Indecisión',
    options: [
      'Tomo mis propias decisiones tan bien como siempre.',
      'Me resulta mas dificil que de costumbre tomar decisiones.',
      'Encuentro mucha mas dificultad que antes para tomar decisiones.',
      'Tengo problemas para tomar cualquier decision.'
    ],
    field: 'bdi_item13',
    uniqueChoice: true,
    required: true
  },
  {
    Component: BdiScoreQuestion,
    question: 'Desvalorización',
    options: [
      'No siento que yo no sea valioso.',
      'No me considero a mi mismo tan valioso y util como solia considerarme.',
      'Me siento menos valioso cuando me comparo con otros.',
      'Siento que no valgo nada.'
    ],
    field: 'bdi_item14',
    uniqueChoice: true,
    required: true
  },
  {
    Component: BdiScoreQuestion,
    question: 'Pérdida de energía',
    options: [
      'Tengo tanta energia como siempre.',
      'Tengo menos energia que la que solia tener.',
      'No tengo suficiente energia para hacer demasiado.',
      'No tengo energia suficiente para hacer nada.'
    ],
    field: 'bdi_item15',
    uniqueChoice: true,
    required: true
  },
  {
    Component: BdiScoreQuestion,
    question: 'Cambios en los hábitos de sueño',
    options: [
      'No he experimentado ningun cambio en mis habitos de sueño.',
      'Duermo un poco mas que lo habitual.',
      'Duermo un poco menos que lo habitual.',
      'Duermo mucho mas que lo habitual.',
      'Duermo mucho menos que lo habitual.',
      'Duermo la mayor parte del dia.',
      'Me despierto 1-2 horas mas temprano y no puedo volver a dormirme.'
    ],
    field: 'bdi_item16',
    uniqueChoice: true,
    required: true
  },
  {
    Component: BdiScoreQuestion,
    question: 'Irritabilidad',
    options: [
      'No estoy mas irritable que lo habitual.',
      'Estoy mas irritable que lo habitual.',
      'Estoy mucho mas irritable que lo habitual.',
      'Estoy irritable todo el tiempo.'
    ],
    field: 'bdi_item17',
    uniqueChoice: true,
    required: true
  },
  {
    Component: BdiScoreQuestion,
    question: 'Cambios en el apetito',
    options: [
      'No he experimentado ningun cambio en mi apetito.',
      'Mi apetito es un poco menor que lo habitual.',
      'Mi apetito es un poco mayor que lo habitual.',
      'Mi apetito es mucho menor que antes.',
      'Mi apetito es mucho mayor que lo habitual.',
      'No tengo apetito en absoluto.',
      'Quiero comer todo el dia.'
    ],
    field: 'bdi_item18',
    uniqueChoice: true,
    required: true
  },
  {
    Component: BdiScoreQuestion,
    question: 'Dificultad de concentración',
    options: [
      'Puedo concentrarme tan bien como siempre.',
      'No puedo concentrarme tan bien como habitualmente.',
      'Me es dificil mantener la mente en algo por mucho tiempo.',
      'Encuentro que no puedo concentrarme en nada.'
    ],
    field: 'bdi_item19',
    uniqueChoice: true,
    required: true
  },
  {
    Component: BdiScoreQuestion,
    question: 'Cansancio o fatiga',
    options: [
      'No estoy mas cansado o fatigado que lo habitual.',
      'Me fatigo o me canso mas facilmente que lo habitual.',
      'Estoy demasiado fatigado o cansado para hacer muchas de las cosas que solia hacer.',
      'Estoy demasiado fatigado o cansado para hacer la mayoria de las cosas que solia hacer.'
    ],
    field: 'bdi_item20',
    uniqueChoice: true,
    required: true
  },
  {
    Component: BdiScoreQuestion,
    question: 'Pérdida de interés en el sexo',
    options: [
      'No he notado ningun cambio reciente en mi interes por el sexo.',
      'Estoy menos interesado en el sexo de lo que solia estarlo.',
      'Estoy mucho menos interesado en el sexo.',
      'He perdido completamente el interes en el sexo.'
    ],
    field: 'bdi_item21',
    uniqueChoice: true,
    required: true
  },

  // PSQI - Cuarta tanda
  {
    Component: HourQuestion,
    question: '¿Durante el último mes, cuál ha sido, usualmente, su hora de acostarse?',
    field: 'psqi_item1',
    required: true
  },
  {
    Component: NumericQuestion,
    question: '¿Durante el último mes, cuánto tiempo ha tardado en dormirse en las noches? (minutos)',
    field: 'psqi_item2',
    required: true
  },
  {
    Component: HourQuestion,
    question: '¿Durante el último mes, a qué hora se ha estado levantando por la mañana?',
    field: 'psqi_item3',
    required: true
  },
  {
    Component: NumericQuestion,
    question: '¿Cuántas horas calcula que habrá dormido verdaderamente cada noche durante el último mes?',
    field: 'psqi_item4',
    required: true
  },
  ...psqiSleepProblemQuestions.map((question, idx) => ({
    Component: FrequencyQuestion,
    question,
    labels: psqiFrequencyOptions,
    field: `psqi_item${idx + 5}`,
    required: true
  })),
  {
    Component: TextQuestion,
    question: 'Si respondió "otras razones", describa cuáles (opcional).',
    field: 'psqi_item14_extraReason',
    required: false
  },
  {
    Component: FrequencyQuestion,
    question: '¿Durante el último mes, cómo valoraría, en conjunto, la calidad de su dormir?',
    labels: ['Bastante buena', 'Buena', 'Mala', 'Bastante mala'],
    field: 'psqi_item15',
    required: true
  },
  {
    Component: FrequencyQuestion,
    question: '¿Durante el último mes, cuántas veces ha tomado medicinas para dormir?',
    labels: psqiFrequencyOptions,
    field: 'psqi_item16',
    required: true
  },
  {
    Component: FrequencyQuestion,
    question: '¿Durante el último mes, cuántas veces ha sentido somnolencia mientras conducía, comía o desarrollaba alguna otra actividad?',
    labels: psqiFrequencyOptions,
    field: 'psqi_item17',
    required: true
  },
  {
    Component: FrequencyQuestion,
    question: '¿Durante el último mes, ha representado para usted mucho problema tener ánimos para realizar actividades?',
    labels: ['Ningun problema', 'Un problema muy ligero', 'Algo de problema', 'Un gran problema'],
    field: 'psqi_item18',
    required: true
  },

  // PSS - Quinta tanda
  ...pssQuestions.map(({ question, invertOrder }, idx) => ({
    Component: FrequencyQuestion,
    question,
    labels: pssLabels,
    invertOrder,
    field: `pss_item${idx + 1}`,
    required: true
  }))
];

export default generalHealtQuestions;
